export default __webpack_public_path__ + "static/media/eu.aad56338.svg";